<template>
  <input :type="type" v-model="localValue" v-on="listeners" v-bind="$attrs" class="c-base-input" :class="[{ 'c-base-input--is-valid': state === true,  'c-base-input--is-invalid': state === false}]">
</template>

<script>
// Supported input types
const types = [ 'text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week' ]

export default {
  name: 'BaseInput',

  model: {
    prop: 'value',
    event: 'update'
  },

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text',
      validator: type => types.includes(type)
    },
    state: {
      type: [Boolean, null],
      default: null
    },
    trim: {
      type: Boolean,
      default: false
    },
    isNumber: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      localValue: this.value
    }
  },

  mounted () {
    this.$watch(() => this.value, value => {
      if (this.localValue !== value) {
        this.localValue = value
      }
    })
  },

  computed: {
    listeners () {
      const { input, change, ...listeners } = this.$listeners
      return {
        input: event => this.onEvent(event, 'input'),
        change: event => this.onEvent(event, 'change', true),
        ...listeners }
    }
  },

  methods: {
    onUpdate (value, force = false) {
      if (this.lazy && !force) {
        return
      }

      if (this.trim) {
        value = value.trim()
      }

      if (this.isNumber) {
        value = parseFloat(value)
      }

      if (this.localValue !== value) {
        this.localValue = value
      }

      this.$emit('update', value)
    },

    onEvent (event, name, force = false) {
      this.onUpdate(event.target.value, force)
      this.$emit(name, event.target.value)
    }
  }
}
</script>
